import { render, staticRenderFns } from "./wageLedger.vue?vue&type=template&id=7edb131e&scoped=true&"
import script from "./wageLedger.vue?vue&type=script&lang=js&"
export * from "./wageLedger.vue?vue&type=script&lang=js&"
import style0 from "./wageLedger.vue?vue&type=style&index=0&id=7edb131e&scoped=true&lang=css&"
import style1 from "./wageLedger.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edb131e",
  null
  
)

export default component.exports